import { IRbac } from '../../apis/__shared/rbac.interfaces';

export const mockRbacFinance: IRbac = {
  dashboard: {
    finance: {
      read: true,
      write: true,
      delete: false,
    },
    people: {
      read: true,
      write: false,
      delete: false,
    },
    events: {
      read: true,
      write: false,
      delete: false,
    },
  },
  students: {
    studentList: {
      read: true,
      write: false,
      delete: false,
    },
    attendance: {
      read: true,
      write: false,
      delete: false,
    },
    fees: {
      read: true,
      write: true,
      delete: false,
    },
    events: {
      read: true,
      write: false,
      delete: false,
    },
    scores: {
      read: false,
      write: false,
      delete: false,
    },
    documents: {
      read: true,
      write: false,
      delete: false,
    },
  },
  staff: {
    staffList: {
      read: true,
      write: false,
      delete: false,
    },
    attendance: {
      read: true,
      write: false,
      delete: false,
    },
    payouts: {
      read: true,
      write: true,
      delete: false,
    },
    events: {
      read: true,
      write: false,
      delete: false,
    },
    documents: {
      read: true,
      write: false,
      delete: false,
    },
  },
  academics: {
    curriculum: {
      read: false,
      write: false,
      delete: false,
    },
    schedules: {
      read: true,
      write: false,
      delete: false,
    },
    lessonPlans: {
      read: false,
      write: false,
      delete: false,
    },
    materials: {
      read: false,
      write: false,
      delete: false,
    },
    assessments: {
      read: false,
      write: false,
      delete: false,
    },
    library: {
      read: false,
      write: false,
      delete: false,
    },
  },
  communications: {
    messaging: {
      read: true,
      write: true,
      delete: false,
    },
    announcements: {
      read: true,
      write: false,
      delete: false,
    },
    concerns: {
      read: true,
      write: false,
      delete: false,
    },
    events: {
      read: true,
      write: false,
      delete: false,
    },
    meetings: {
      read: true,
      write: false,
      delete: false,
    },
  },
  finance: {
    financeList: {
      read: true,
      write: true,
      delete: false,
    },
    scholarships: {
      read: true,
      write: true,
      delete: false,
    },
    financialReports: {
      read: true,
      write: true,
      delete: false,
    },
  },
  analytics: {
    performance: {
      read: true,
      write: false,
      delete: false,
    },
    customDashboards: {
      read: true,
      write: false,
      delete: false,
    },
  },
  administration: {
    transport: {
      read: false,
      write: false,
      delete: false,
    },
    inventory: {
      read: false,
      write: false,
      delete: false,
    },
    healthAndSafety: {
      read: false,
      write: false,
      delete: false,
    },
  },
  users: {
    parents: {
      read: true,
      write: false,
      delete: false,
    },
    visitors: {
      read: false,
      write: false,
      delete: false,
    },
    guests: {
      read: false,
      write: false,
      delete: false,
    },
  },
  settings: {
    userManagement: {
      read: false,
      write: false,
      delete: false,
    },
    complianceManagement: {
      read: true,
      write: false,
      delete: false,
    },
  },
  profile: {
    personalDetails: {
      read: true,
      write: true,
      delete: false,
    },
    documents: {
      read: true,
      write: true,
      delete: true,
    },
    calendar: {
      read: true,
      write: true,
      delete: true,
    },
    leaves: {
      read: true,
      write: false,
      delete: false,
    },
  },
  guardian: {
    dashboard: { read: false, write: false, delete: false },
    academicsSchedule: { read: false, write: false, delete: false },
    academicsCurriculum: { read: false, write: false, delete: false },
    academicsLessonPlans: { read: false, write: false, delete: false },
    academicsMaterials: { read: false, write: false, delete: false },
    academicsAssessments: { read: false, write: false, delete: false },
    academicsHomework: { read: false, write: false, delete: false },
    academicsAttendance: { read: false, write: false, delete: false },
    academicsLibrary: { read: false, write: false, delete: false },
    fees: { read: false, write: false, delete: false },
    transport: { read: false, write: false, delete: false },
    documents: { read: false, write: false, delete: false },
    eventsCommunication: { read: false, write: false, delete: false },
    concerns: { read: false, write: false, delete: false },
    profile: { read: false, write: false, delete: false },
    settings: { read: false, write: false, delete: false },
  },
};
